jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
});


function myFunction() {
  const checkbox = document.getElementById("ATLcheck");
  const box = document.getElementById("ATLtext");

  if (checkbox.checked) {
    box.style.display = "block";
  } else {
    box.style.display = "none";
  }
}

document.getElementById('giftWrapCheck').addEventListener('change', function() {
    var accordion = document.getElementById('accordion');
    if (this.checked) {
        accordion.style.display = 'block';
    } else {
        accordion.style.display = 'none';
    }
});

